import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MainCardContainer from '../../components/MainCardContainer/';
import CardRow from '../../components/CardRow';
import Loader from './../../components/Loader';
import ReportsTable from './components/ReportsTable';
import { STAFFID } from './../../data/constants/';
import * as actions from './../../data/reports/actions';
import { useLanguage } from '../../context/LanguageContext';

class Reports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportsList: []
    };
  }
  componentDidMount() {
    const staffId = sessionStorage.getItem(STAFFID);
    const { fetchReportsList } = this.props;

    fetchReportsList(staffId);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { isFetching, reportsList } = nextProps;
    if (!isFetching && reportsList.entries.length > 0) {
      const generatedReportsList = [];
      reportsList.entries.forEach((report) => {
        const reportItem = {
          title: report.name,
          subtitle: `Subtitle goes here ${report.uniqueKey}`,
          type: report.contentType,
          uniqueIdentifier: report.uniqueKey,
        };
        generatedReportsList.push(reportItem);
      });

      this.setState({ reportsList: generatedReportsList });
    }
  }

  render() {
    const REPORTS = this.props.labels?.REPORTS || {};
    const message = (!this.props.error.reportsListError) ?
    REPORTS.NO_REPORTS_MESSAGE : this.props.error.message;
    const { isFetching } = this.props;
    const reportList = (this.state.reportsList.length !== 0) ?
    this.state.reportsList : (<p className="no-reports-message">{message}</p>);
    return (
      <div>
        { isFetching ? <Loader /> :
        <MainCardContainer
          headTitle={REPORTS.TITLE}
          headSubtitle={REPORTS.SUBTITLE}
          content={[
            <CardRow
              key={1}
              cardNumber={1}
              cards={[<ReportsTable key={1} reportsList={reportList} />]}
            />
          ]}
        />
        }
      </div>
    );
  }
}

Reports.defaultProps = {
  isFetching: false,
  reportsList: {},
  error: {},
  fetchReportsList: () => {},
};

Reports.propTypes = {
  isFetching: PropTypes.bool,
  reportsList: PropTypes.any.isRequired,
  // staffId: PropTypes.string,
  fetchReportsList: PropTypes.func.isRequired,
  error: PropTypes.object.isRequired,
  labels: PropTypes.object,
};

const mapStateToProps = state => ({ ...state.reports });

const mapDispatchToProps = dispatch => ({
  fetchReportsList: staffId => dispatch(actions.fetchReportsList(staffId)),
});

const ConnectedReports = connect(mapStateToProps, mapDispatchToProps)(Reports);

// Wrapper to inject language context
function ReportsWrapper(props) {
  const { labels } = useLanguage();
  return <ConnectedReports {...props} labels={labels} />;
}

export default ReportsWrapper;
